import { render } from "./TextArea.vue?vue&type=template&id=61d89c4a&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=61d89c4a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-61d89c4a"

export default script